/**
 * Journal Routes Configuration
 *
 * This file contains all journal-related route definitions extracted from the main router.
 * It provides better organization and maintainability for journal-specific routing logic.
 */

import type { RouteRecordRaw } from 'vue-router'
import { loadLocales } from '@/utils/i18n.utils'
import { br } from '@/plugins/trackerPlugin'

// Journal component imports
const JournalLayout = () => import('@/layouts/JournalLayout.vue')
const JournalRoot = () => import('@/pages/journal/JournalRoot.vue')

/**
 * Get journal route configuration
 */
export function getJournalRoutes(): RouteRecordRaw {
  return {
    name: 'journalLayout',
    path: 'journal',
    alias: '',
    component: JournalLayout,
    beforeEnter: async () => {
      await loadLocales('journal')
    },
    props: true,
    meta: {
      requiresAuth: true,
      requiresMatched: true,
      trackingName: br.appActionFeature.journal,
      section: 'journal'
    },
    children: [
      {
        name: 'journal',
        path: '/journal/',
        component: JournalRoot,
        props: true,
        meta: {
          requiresAuth: true,
          layoutContainsAds: false,
          nameForLabels: 'buttons.newEntry',
          addNewRouteName: 'newJournalEntry'
        }
      },
      {
        name: 'newJournalEntry',
        path: '/journal/entry',
        redirect: () => {
          return '/journal/?itemId=0'
        }
      },
      {
        name: 'journalEntry',
        path: '/journal/entry/:itemId',
        redirect: (to) => {
          const itemId =
            to.params.itemId instanceof Array
              ? to.params.itemId[0]
              : to.params.itemId || '0'
          return '/journal/?itemId=' + itemId
        }
      }
    ]
  }
}
